"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));
var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));
var React = _interopRequireWildcard(require("react"));
var PropTypes = _interopRequireWildcard(require("prop-types"));
var _reactLifecyclesCompat = require("react-lifecycles-compat");
var _is = require("@utiljs/is");
var _Portal = _interopRequireDefault(require("../core/Portal"));
var _ToastEntity = _interopRequireDefault(require("./ToastEntity"));
var _interface = require("./interface");
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = (0, _getPrototypeOf2.default)(t); if (r) { var s = (0, _getPrototypeOf2.default)(this).constructor; e = _Reflect$construct(o, arguments, s); } else e = o.apply(this, arguments); return (0, _possibleConstructorReturn2.default)(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof _getOwnPropertySymbols.default === "function") for (var i = 0, p = (0, _getOwnPropertySymbols.default)(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var Toast = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(Toast, _React$Component);
  var _super = _createSuper(Toast);
  function Toast(props) {
    var _this;
    (0, _classCallCheck2.default)(this, Toast);
    _this = _super.call(this, props);
    _this.handleClose = function () {
      var onClose = _this.props.onClose;
      if ((0, _is.isFunction)(onClose)) {
        onClose();
      }
    };
    _this.handleClick = function () {
      var onClick = _this.props.onClick;
      if ((0, _is.isFunction)(onClick)) {
        onClick();
      }
    };
    _this.state = {
      visible: _this.props.visible
    };
    return _this;
  }
  (0, _createClass2.default)(Toast, [{
    key: "render",
    value: function render() {
      var _a = this.props,
        onClose = _a.onClose,
        visibleProps = _a.visible,
        popupContainer = _a.popupContainer,
        restProps = __rest(_a, ["onClose", "visible", "popupContainer"]);
      var visible = this.state.visible;
      return visible ? ( /*#__PURE__*/React.createElement(_Portal.default, {
        container: popupContainer
      }, /*#__PURE__*/React.createElement(_ToastEntity.default, (0, _assign.default)({}, restProps, {
        onClose: this.handleClose,
        onClick: this.handleClick
      })))) : null;
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (props.visible !== state.visible) {
        return {
          visible: props.visible
        };
      }
      return null;
    }
  }]);
  return Toast;
}(React.Component);
Toast.propTypes = {
  title: PropTypes.node,
  duration: PropTypes.number,
  closable: PropTypes.bool,
  onClose: PropTypes.func,
  status: PropTypes.oneOf([_interface.statusTypes]),
  prefix: PropTypes.string,
  visible: PropTypes.bool,
  popupContainer: PropTypes.oneOfType([PropTypes.instanceOf(Element), PropTypes.func]),
  onClick: PropTypes.func
};
Toast.defaultProps = {
  title: '',
  duration: 3000,
  closable: true,
  status: undefined,
  prefix: undefined,
  onClose: function onClose() {},
  visible: false,
  children: undefined,
  popupContainer: document.body,
  onClick: undefined
};
// 先不暴露此组件，有实际需求再添加。
// FIXME: 16.4 getDerivedStateFromProps 反模式，只能完全受控（组件使用变得很繁琐）
// TODO: 获取页面高计算最大放置的数量
(0, _reactLifecyclesCompat.polyfill)(Toast);
var _default = exports.default = Toast;